import { ContentDataBlockText } from '@amf/shared/components/content/Content';

interface ParagraphProps {
  block: ContentDataBlockText;
}

export default function Paragraph({ block }: ParagraphProps) {
  return <p dangerouslySetInnerHTML={{ __html: block.data.text }} />;
}
